module.exports = __webpack_public_path__ + "static/media/TUNE_6370.5633976b.jpg";